/**
 * Global Keyboard Shortcuts
 * Register site-wide keyboard shortcuts
 *
 * Usage: Add x-data="keyboardShortcuts" to a root element (e.g., body or #app)
 */
export default function KeyboardShortcuts() {
  return {
    init() {
      window.addEventListener('keydown', (e) => this.handleKeydown(e));
    },

    // Flat early-return keymap; cognitive load is low.
    // fallow-ignore-next-line complexity
    handleKeydown(e) {
      const isTyping = ['INPUT', 'TEXTAREA', 'SELECT'].includes(
        document.activeElement?.tagName,
      );
      const isContentEditable = document.activeElement?.isContentEditable;

      // Cmd/Ctrl+K - Open search
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        this.openSearch();
        return;
      }

      // "/" - Open search (when not typing)
      if (e.key === '/' && !isTyping && !isContentEditable) {
        e.preventDefault();
        this.openSearch();
        return;
      }

      // "?" - Show keyboard shortcuts help (when not typing)
      if (e.key === '?' && !isTyping && !isContentEditable) {
        e.preventDefault();
        this.openShortcutsHelp();
        return;
      }
    },

    openSearch() {
      window.dispatchEvent(
        new CustomEvent('modal:open', {
          detail: { id: 'search-modal' },
        }),
      );
    },

    openShortcutsHelp() {
      window.dispatchEvent(
        new CustomEvent('modal:open', {
          detail: { id: 'shortcuts-modal', size: 'sm' },
        }),
      );
    },
  };
}
